import React from "react";
import { Container } from "react-bootstrap";
import { useIsMobile } from "../../utils/responsive";
export default function Banner2() {
  const isMobile = useIsMobile();
  return (
    <Container fluid className="p-0">
      <div className="d-flex justify-content-center">
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
        )}
        <div
          style={{
            width: isMobile ? "100%" : "90%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            // borderRight: "1px solid black",
            // borderLeft: "1px solid black",

            alignItems: "center",
          }}
        >
          <div
            style={{
              padding: isMobile ? "20px 40px" : "40px 150px",
            }}
          >
            <p className="body-lg m-0 text-center">
              NOW THAT YOU'RE ARMED WITH THE KNOWLEDGE OF HOW TO USE THE COLOR
              WHEEL AND HOW TO MIX COLORS, YOU'LL BE INSPIRED TO CREATE YOUR OWN
              <br />
              <span className="accent-text">perfect palettes.</span>
            </p>
          </div>
        </div>
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              borderLeft: "1px solid black",
            }}
          ></div>
        )}
      </div>
    </Container>
  );
}
